module.exports = __webpack_public_path__ + "static/media/commercial-security.8471b3db.jpg";